import React from "react";
import _ from "lodash";
import moment from "moment"

const AllAPCMPatientsProgramCell = ({ data }) => {
  let apcmEnrollmentDate = "-";
  let monthDiff = "";
  if(data.apcm_consent_type_change_ts){
        apcmEnrollmentDate = moment(data.apcm_consent_type_change_ts).format('MM/DD/YYYY')    
        monthDiff = moment().diff( moment(data.apcm_consent_type_change_ts),"months")  ;
  }      
  
  return (
    <div>
      <div
        className="value-box"
        style={{
          width: "100%",
          display: "flex",
          flex: 1,
          flexDirection: "column",
          padding: 0,
        }}
      >
        <div
          style={{ display: "flex", justifyContent: "flex-start", padding: 0 }}
        >
          <span style={{ fontWeight: 400 }}>APCM Service Level:</span>
          <span style={{ paddingLeft: 15 }}>
            {data.apcm_service_level ? data.apcm_service_level : "-"}
          </span>
        </div>
        <div
          style={{ display: "flex",flexDirection:'column', alignItems:'flex-start',justifyContent: "flex-start", padding: 0 }}
        >
          <div style={{ fontWeight: 400 }}>APCM Enrollment Date</div>
          <div>
            {apcmEnrollmentDate} <span style={{paddingLeft:15}}>
                {monthDiff ? (monthDiff == 1 ? (monthDiff + ' Month') :( monthDiff + ' Months')) : ""}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllAPCMPatientsProgramCell;
